import { useState } from "react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

interface LoginProps {
  onLogin: () => void;
}

export function Login({ onLogin }: LoginProps) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      const response = await fetch('/api/auth', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });
      
      const data = await response.json();
      
      if (data.success) {
        localStorage.setItem('authenticated', 'true');
        onLogin();
      } else {
        setError(true);
        setTimeout(() => setError(false), 2000);
      }
    } catch (err) {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-8">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-6xl font-bold mb-2">2026.</h1>
          <p className="text-gray-400 text-sm">Introdueix la contrasenya</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Contrasenya"
              className={`bg-white/5 border-white/20 text-white placeholder:text-gray-500 ${
                error ? 'border-red-500' : ''
              }`}
              autoFocus
            />
            {error && (
              <p className="text-red-400 text-xs mt-2">Contrasenya incorrecta</p>
            )}
          </div>
          
          <Button
            type="submit"
            className="w-full bg-white text-black hover:bg-gray-200"
          >
            Accedir
          </Button>
        </form>
      </div>
    </div>
  );
}
